import { useSessionData } from '@confluence/session-data/entry-points/useSessionData';

export const useIsPageEligibleForAdminAnnouncementBanner = () => {
	const { edition } = useSessionData();
	return edition === 'PREMIUM' || edition === 'STANDARD';
};
